import { selectVillage } from './selectVillage';
import { IState } from '../../store';

export function selectVillageStationInfoList(state: IState) {
  const village = selectVillage(state);

  return village.stationInfoList ?? [];
}

export function selectVillageStationsIds(state: IState): number[] {
  return selectVillageStationInfoList(state).map(road => road.stationId);
}
